<header class="w-full z-40 relative">
  <!-- Top Announcement Strip -->
  <div class="bg-[#0e3b2e] text-white text-xs py-2 border-b border-[#e6b012]/30">
    <div class="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">

      <!-- Left Announcement Link -->
      <a (click)="previewDoc()"
        class="hover:text-[#e6b012] cursor-pointer inline-flex items-center gap-2 font-medium transition-colors">
        <span class="w-2 h-2 rounded-full bg-[#e6b012] animate-pulse"></span>
        <mat-icon class="!text-[16px] !w-4 !h-4 text-[#e6b012]">campaign</mat-icon>
        <span>Dira ya Maendeleo 2050 (Tanzania National Vision 2050)</span>
      </a>

      <!-- Right Utility Actions -->
      <div class="flex items-center gap-6 font-semibold">
        <button (click)="
            translationService.setLanguage(
              translationService.getLanguageSignal()() === 'en' ? 'sw' : 'en'
            )
          " class="inline-flex items-center gap-1.5 hover:text-[#e6b012] cursor-pointer transition-colors">
          <mat-icon class="!text-[16px] !w-4 !h-4 text-[#e6b012]">translate</mat-icon>
          <span>{{ translationService.currentLang() === 'en' ? 'Swahili' : 'English' }}</span>
        </button>

        <a class="hidden sm:inline-flex items-center gap-1.5 hover:text-[#e6b012] cursor-pointer transition-colors">
          <mat-icon class="!text-[16px] !w-4 !h-4 text-[#e6b012]">help_outline</mat-icon>
          <span>Help &amp; Support</span>
        </a>
      </div>

    </div>
  </div>

  <!-- Main Navigation Bar -->
  <nav class="bg-white/95 backdrop-blur-md border-b border-amber-900/10 shadow-xs">
    <div class="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">

      <!-- Left cluster: logo + divider + nav -->
      <div class="flex items-center gap-6">
        <!-- Logo & Brand Title -->
        <a routerLink="/home" class="flex items-center gap-3 group">
          <img src="favicon.ico" alt="Tanzania Coat of Arms"
            class="w-11 h-11 rounded-lg p-0.5 bg-[#0e3b2e] shadow-sm transition-transform group-hover:scale-105"
            draggable="false" />
          <div class="flex flex-col">
            <span class="text-base font-bold text-[#0e3b2e] tracking-tight leading-none">Government MEL System</span>
            <span class="text-[10px] font-bold text-[#818181] uppercase tracking-wider mt-1">The United Republic of
              Tanzania</span>
          </div>
        </a>

        <!-- Vertical divider -->
        <span class="hidden lg:block h-8 w-px bg-slate-200" aria-hidden="true"></span>

        <!-- Navigation Links -->
        <ul class="hidden lg:flex items-center gap-8 text-xs font-extrabold uppercase tracking-wider text-[#0e3b2e]">
          <li>
            <a routerLink="/home" (click)="scrollToSection($event, 'home')"
              class="hover:text-[#e6b012] transition-colors cursor-pointer py-2 border-b-2"
              [class.border-[#e6b012]]="currentSection === 'home'"
              [class.border-transparent]="currentSection !== 'home'">
              Home
            </a>
          </li>
          <li>
            <a (click)="scrollToSection($event, 'about')"
              class="hover:text-[#e6b012] transition-colors cursor-pointer py-2 border-b-2"
              [class.border-[#e6b012]]="currentSection === 'about'"
              [class.border-transparent]="currentSection !== 'about'">
              About
            </a>
          </li>
          <li>
            <a routerLink="/frameworks"
              class="hover:text-[#e6b012] transition-colors cursor-pointer py-2 border-b-2 border-transparent">
              M&amp;E Frameworks
            </a>
          </li>
          <li>
            <a routerLink="/projects"
              class="hover:text-[#e6b012] transition-colors cursor-pointer py-2 border-b-2 border-transparent">
              Projects
            </a>
          </li>
          <li>
            <a routerLink="/documents" (click)="scrollToSection($event, 'documents')"
              class="hover:text-[#e6b012] transition-colors cursor-pointer py-2 border-b-2"
              [class.border-[#e6b012]]="currentSection === 'documents'"
              [class.border-transparent]="currentSection !== 'documents'">
              Documents
            </a>
          </li>
          <li>
            <a (click)="scrollToSection($event, 'faqs')"
              class="hover:text-[#e6b012] transition-colors cursor-pointer py-2 border-b-2"
              [class.border-[#e6b012]]="currentSection === 'faqs'"
              [class.border-transparent]="currentSection !== 'faqs'">
              FAQs
            </a>
          </li>
        </ul>
      </div>

      <!-- Right Controls: Language Selector & Sign In Button -->
      <div class="flex items-center gap-3">
        <!-- Language Selector Pill -->
        <button (click)="
            translationService.setLanguage(
              translationService.getLanguageSignal()() === 'en' ? 'sw' : 'en'
            )
          "
          class="px-3.5 py-2 rounded-full border border-slate-200 bg-[#fcfbf9] hover:bg-slate-100 text-[#0e3b2e] text-xs font-bold transition-all flex items-center gap-2 cursor-pointer shadow-2xs"
          [title]="'Switch Language' | translate">
          <mat-icon class="!text-[16px] !w-4 !h-4 text-[#e6b012]">language</mat-icon>
          <span class="uppercase tracking-wider font-extrabold">{{ translationService.currentLang() === 'en' ? 'SW' :
            'EN' }}</span>
          <span class="text-slate-400 font-normal">|</span>
          <span class="text-slate-500 font-semibold">{{ translationService.currentLang() === 'en' ? 'Kiswahili' :
            'English' }}</span>
        </button>

        <!-- Sign In Button -->
        <a routerLink="/login"
          class="px-6 py-2.5 rounded-full bg-[#0e3b2e] hover:bg-[#07231a] text-white font-extrabold text-xs tracking-wider uppercase shadow-md hover:shadow-lg transition-all active:scale-95 cursor-pointer flex items-center gap-2">
          <mat-icon class="!text-[16px] !w-4 !h-4 text-[#e6b012]">login</mat-icon>
          <span>Sign In</span>
        </a>
      </div>

    </div>
  </nav>
</header>

<!-- Floating Liquid Glass Navbar (On Scroll) -->
@if (showFloatingNavbar) {
<div
  class="fixed top-4 left-1/2 -translate-x-1/2 w-[96%] max-w-[1400px] bg-[#0e3b2e]/85 backdrop-blur-2xl rounded-2xl text-white z-50 shadow-2xl border border-white/20 transition-all duration-300 px-6 py-3 flex items-center justify-between">

  <!-- Left Brand -->
  <a routerLink="/home" class="flex items-center gap-3">
    <img src="favicon.ico" alt="Logo" class="w-9 h-9 rounded-lg bg-white p-0.5 shadow-sm" draggable="false" />
    <div class="flex flex-col">
      <span class="text-xs font-extrabold tracking-tight text-white hidden sm:inline leading-none">Government MEL
        System</span>
      <span class="text-[10px] font-bold text-[#e6b012] uppercase tracking-wider hidden sm:inline mt-0.5">The United
        Republic of Tanzania</span>
    </div>
  </a>

  <!-- Nav Links -->
  <ul class="flex items-center gap-6 text-xs font-extrabold uppercase tracking-wider text-white/90">
    <li><a (click)="scrollToSection($event, 'home')"
        class="hover:text-[#e6b012] transition-colors cursor-pointer">Home</a></li>
    <li><a (click)="scrollToSection($event, 'about')"
        class="hover:text-[#e6b012] transition-colors cursor-pointer">About</a></li>
    <li><a routerLink="/frameworks" class="hover:text-[#e6b012] transition-colors cursor-pointer">Frameworks</a></li>
    <li><a routerLink="/projects" class="hover:text-[#e6b012] transition-colors cursor-pointer">Projects</a></li>
    <li><a (click)="scrollToSection($event, 'documents')"
        class="hover:text-[#e6b012] transition-colors cursor-pointer hidden md:inline">Documents</a></li>
    <li><a (click)="scrollToSection($event, 'faqs')"
        class="hover:text-[#e6b012] transition-colors cursor-pointer hidden md:inline">FAQs</a></li>
  </ul>

  <!-- Right Controls: Floating Language & Sign In -->
  <div class="flex items-center gap-3">
    <button (click)="
          translationService.setLanguage(
            translationService.getLanguageSignal()() === 'en' ? 'sw' : 'en'
          )
        "
      class="px-3 py-1.5 rounded-xl text-[#e6b012] text-xs font-bold tracking-wider transition-all flex items-center gap-1.5 cursor-pointer uppercase">
      <mat-icon class="!text-[14px] !w-3.5 !h-3.5">language</mat-icon>
      <span>{{ translationService.currentLang() === 'en' ? 'SW' : 'EN' }}</span>
    </button>

    <a routerLink="/login"
      class="px-5 py-2 rounded-xl bg-[#e6b012] hover:bg-[#d4a00e] text-[#0e3b2e] font-extrabold text-xs tracking-wider uppercase transition-all shadow-md active:scale-95 cursor-pointer flex items-center gap-1.5">
      <mat-icon class="!text-[14px] !w-3.5 !h-3.5">login</mat-icon>
      <span>Sign In</span>
    </a>
  </div>
</div>
}